import { render, staticRenderFns } from "./LangSwitcher.vue?vue&type=template&id=423b853c&scoped=true"
import script from "./LangSwitcher.vue?vue&type=script&lang=js"
export * from "./LangSwitcher.vue?vue&type=script&lang=js"
import style0 from "./LangSwitcher.vue?vue&type=style&index=0&id=423b853c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423b853c",
  null
  
)

export default component.exports